// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid[data-v-74082ba3]{display:grid;padding:0 5px;grid-gap:10px;grid-template-columns:repeat(auto-fill, minmax(calc(min(50%, 210px) - 5px), 1fr));width:calc(100% - 40px)}@media(max-width: 768px){.grid[data-v-74082ba3]{width:calc(100% - 2px);grid-gap:5px}}.grid>.item[data-v-74082ba3]{aspect-ratio:1/1;position:relative}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
